const path = window.location.pathname || "";
const host = (window.location.host || "").toLowerCase();

const resolvePublicBase = () => {
  if (path.includes("/finaloutput/public_html")) return "/finaloutput/public_html";
  if (path.includes("/backend/public")) return "/backend/public";
  if (host.includes("localhost") || host.startsWith("127.0.0.1")) return "/finaloutput/public_html";
  return "";
};

export const RUNTIME_PUBLIC_BASE = resolvePublicBase();
export const RUNTIME_API_BASE = `${RUNTIME_PUBLIC_BASE}/api`;
